const COMMENT_MODEL_CLASS_NAME = 'Comment'

const COMMENT_MODEL_KEY = {
  VALUE: 'value',
  ARTICLES: 'articles',
  COMMENTS: 'comments',
  MOTIVATIONS: 'motivations',
  REPLIES: 'replies',
  REPORTS: 'reports',
  USER: 'user',
  COMMENT_COUNT: 'commentCount',
  // Foreign keys
  USER_ID: 'userId'
}

const COMMENT_MODEL_KEY_POINTER = COMMENT_MODEL_KEY.ID
const COMMENT_MODEL_VALIDATOR = {
  [COMMENT_MODEL_KEY.VALUE]: [
    5,
    500
  ]
}

const COMMENT_MODEL_PLACEHOLDER = {
  [COMMENT_MODEL_KEY.VALUE]: 'Write a response...'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const COMMENT_MODEL_ASSOCIATION = {
  [COMMENT_MODEL_KEY.ARTICLES]: 'Article',
  [COMMENT_MODEL_KEY.COMMENTS]: COMMENT_MODEL_CLASS_NAME,
  [COMMENT_MODEL_KEY.MOTIVATIONS]: 'Motivation',
  [COMMENT_MODEL_KEY.REPLIES]: COMMENT_MODEL_CLASS_NAME,
  [COMMENT_MODEL_KEY.REPORTS]: 'Report',
  [COMMENT_MODEL_KEY.USER]: 'User'
}

const COMMENT_HTML_ANCHOR_PREFIX = 'comment'

export {
  COMMENT_MODEL_CLASS_NAME,
  COMMENT_MODEL_KEY,
  COMMENT_MODEL_KEY_POINTER,
  COMMENT_MODEL_VALIDATOR,
  COMMENT_MODEL_PLACEHOLDER,
  COMMENT_MODEL_ASSOCIATION,
  COMMENT_HTML_ANCHOR_PREFIX
}
